import { useState } from 'react';

const useMyPagination = (items, itemsPerPage) => {
  const [page, setPage] = useState(1);

  const count = Math.ceil(items?.length / itemsPerPage);

  const lastItemIndex = page * itemsPerPage;
  const firstItemIndex = page * itemsPerPage - itemsPerPage;
  const currentItems = items?.slice(firstItemIndex, lastItemIndex);

  return { setPage, count, currentItems };
};

export default useMyPagination;
